<template>
  <div>
    <!-- <b-button size="sm" variant="outline-success" :to="{ name: 'admin-user' }">
      Voltar
    </b-button> -->

    <b-card>
      <b-tabs>
        <b-tab title="Commodity">
          <b-form class="custom-form" @submit.prevent>
            <b-row>
              <!-- <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="_id" placeholder="_ID" v-model="form._id" disabled />
                  <label for="_id">_ID</label>
                </div>
              </b-col> -->
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="id" placeholder="ID" v-model="form.id" />
                  <label for="id">ID</label>
                </div>
              </b-col>
              <b-col md="12"></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="labelPtBr" placeholder="Nome PT-BR" v-model="form.labelPtBr" />
                  <label for="name">Label PT-BR</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="labelEnEu" placeholder="Nome EN-EU" v-model="form.labelEnEu" />
                  <label for="name">Label EN-EU</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="labelEsEs" placeholder="Nome ES-ES" v-model="form.labelEsEs" />
                  <label for="name">Label ES-ES</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="labelEsAr" placeholder="Nome ES-AR" v-model="form.labelEsAr" />
                  <label for="name">Label ES-AR</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="labelPtPt" placeholder="Nome PT-PT" v-model="form.labelPtPt" />
                  <label for="labelPtPt">Label PT-PT</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="labelZhCn" placeholder="Nome ZH-CN" v-model="form.labelZhCn" />
                  <label for="labelZhCn">Label ZH-CN</label>
                </div>
              </b-col>
              <b-col md="12"></b-col>
              <b-col md="3">
                <div class="form-label-group">
                  <b-form-input id="filter" placeholder="Filtro" v-model="form.filter" />
                  <label for="name">Filtro</label>
                </div>
              </b-col>
              <b-col md="3">
                <div class="form-label-group">
                  <b-form-input id="order" placeholder="Ordem" v-model="form.order" />
                  <label for="name">Ordem</label>
                </div>
              </b-col>
              <b-col md="3">
                <div class="form-label-group">
                  <b-form-input id="icon" placeholder="Icone" v-model="form.icon" />
                  <label for="name">Icone</label>
                </div>
              </b-col>
              <b-col md="3">
                <div class="form-label-group">
                  <b-form-input id="mne" placeholder="Minemonico" v-model="form.mne" />
                  <label for="name">Minemonico</label>
                </div>
              </b-col>
              <b-col md="12"></b-col>
              
              <b-col class="mb-2" md="12"><hr /></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-created"
                    placeholder="Data Criação"
                    v-model="form.dt_create"
                    disabled
                  />
                  <label for="dt-created">Data Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-created"
                    placeholder="Email Criação"
                    v-model="form.email_create"
                    disabled
                  />
                  <label for="email-created">Email Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-update"
                    placeholder="Data Alteração"
                    v-model="form.dt_update"
                    disabled
                  />
                  <label for="dt-update">Data Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-update"
                    placeholder="Email Alteração"
                    v-model="form.email_update"
                    disabled
                  />
                  <label for="email-update">Email Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-delete"
                    placeholder="Data Desativação"
                    v-model="form.dt_delete"
                    disabled
                  />
                  <label for="dt-delete">Data Desativação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-delete"
                    placeholder="Email Desativação"
                    v-model="form.email_delete"
                    disabled
                  />
                  <label for="email-delete">Email Desativação</label>
                </div>
              </b-col>

              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox id="active" name="active" checked="true" v-model="form.active">
                    Ativo
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col>
                <b-button type="submit" variant="primary" class="mr-1" @click="onSubmit">
                  Enviar
                </b-button>
                <b-button
                  variant="danger"
                  class="mr-1"
                  @click="onBackPage"
                >
                  Voltar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
        <b-tab title="Configuração">
          <b-form class="custom-form" @submit.prevent style="width:100%">
            <b-row>
              <!-- <b-col md="6">
                <div class="form-label-group">
                  <label for="origin-list">Origem</label>
                  <b-form-group label="Origem" label-for="origin-list">
                  <v-select
                    id="origin-list"
                    v-model="form.origin"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="origins"
                  >
                    <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                  </v-select>
                </b-form-group>
                </div>
              </b-col> -->
              <b-col md="6">
                <div class="form-label-group">
                  <label for="origin-list">Origem</label>
                  <b-form-group label="Origem" label-for="origin-list">
                    <v-select
                      id="origin-list"
                      v-model="form.origins"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      multiple
                      :options="origins"
                    >
                      <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <label for="country-list">País</label>
                  <b-form-group label="País" label-for="country-list">
                    <v-select
                      id="country-list"
                      v-model="form.country"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      multiple
                      :options="country"
                    >
                      <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <label for="content-list">Conteúdo</label>
                  <b-form-group label="Conteúdo" label-for="content-list">
                    <v-select
                      id="content-list"
                      v-model="form.content"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      multiple
                      :options="content"
                    >
                      <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <label for="characteristic-list">Caracteristica</label>
                  <b-form-group label="Caracteristica" label-for="characteristic-list">
                    <v-select
                      id="characteristic-list"
                      v-model="form.characteristic"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      multiple
                      :options="characteristic"
                    >
                      <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <label for="periodicity-list">Periodicidade</label>
                  <b-form-group label="Periodicidade" label-for="periodicity-list">
                    <v-select
                      id="periodicity-list"
                      v-model="form.periodicity"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      multiple
                      :options="periodicity"
                    >
                      <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BTabs,
  BTab,
  BCard,
} from "bootstrap-vue";
import commodityService from "@/providers/commodityService";
import dropdownService from "@/providers/dropdownService";
import convertDatetimeHelper from '@/helpers/convert-datetime-helper';
import messagesNotifyHelper from '@/helpers/messages-notify-helper';
import vSelect from "vue-select";
import AppConstants from '@/appConstants';

export default {
  props: {},
  data() {
    return {
      dataID: null,
      origins: [],
      country: [],
      content: [],
      characteristic: [],
      periodicity: [],
      form: {
        _id: "",
        id: "",
        labelPtBr: "",
        labelEnEu: "",
        labelEsEs: "",
        labelEsAr: "",
        labelPtPt: "",
        labelZhCn: "",
        filter: "",
        icon: "",
        order: "",
        mne: "",
        origins: "",
        country: "",
        content: "",
        characteristic: "",
        periodicity: "",
        active: true,
        dt_create: "",
        dt_update: "",
        dt_delete: "",
        email_create: "",
        email_update: "",
        email_delete: "",
      },
    };
  },
  created() {
    if (this.isUpdate) {
      this.dataID = this.$route.params.id;
      // console.log("dataid: ", this.dataID);
    }

    this.loadData();
  },
  watch: {},
  computed: {
    isUpdate() {
      if (this.$route.params.id) {
        return true;
      }
      return false;
    },
  },
  methods: {
    onBackPage() {
      this.$router.push(AppConstants.NAVIGATION_PAGE_ADM_COMMODITY);
    },
    onSubmit() {
      const form = JSON.parse(JSON.stringify(this.form));
      if (this.form.origins.length > 0) {
        form.origins = form.origins.map((item) => item.id);
      }
      if (this.form.content.length > 0) {
        form.content = form.content.map((item) => item.id);
      }
      if (this.form.characteristic.length > 0) {
        form.characteristic = form.characteristic.map((item) => item.id);
      }
      if (this.form.periodicity.length > 0) {
        form.periodicity = form.periodicity.map((item) => item.id);
      }
      if (this.form.country.length > 0) {
        form.country = form.country.map((item) => item.id);
      }
      commodityService
        .registerCommodity(form, new URLSearchParams())
        .then(() => {
          // console.log(res);
          if (this.isUpdate) {
            messagesNotifyHelper.updatedRecordNotify();
          } else {
            messagesNotifyHelper.createdRecordNotify();
            this.onBackPage();
          }
        })
        .catch((err) => console.log(err));
    },
    getCommodityDetails() {
      const params = new URLSearchParams();
      params.append("id", this.dataID);
      commodityService
        .getCommodityDetails(params)
        .then((res) => {
          // console.log(res);
          this.form._id = res._id;
          this.form.id = res.id;
          this.form.labelPtBr = res.labelPtBr;
          this.form.labelEnEu = res.labelEnEu;
          this.form.labelEsEs = res.labelEsEs;
          this.form.labelEsAr = res.labelEsAr;
          this.form.labelPtPt = res.labelPtPt;
          this.form.labelZhCn = res.labelZhCn;
          this.form.filter = res.filter;
          this.form.icon = res.icon;
          this.form.order = res.order;
          this.form.origins = res.origins;
          this.form.country = res.country;
          this.form.content = res.content;
          this.form.characteristic = res.characteristic;
          this.form.periodicity = res.periodicity;
          this.form.active = res.active;
          this.form.dt_create = convertDatetimeHelper.convertStringToDateTime(res.dt_create);
          this.form.dt_update = res.dt_update ? convertDatetimeHelper.convertStringToDateTime(res.dt_update) : res.dt_update;
          this.form.dt_delete = res.dt_delete ? convertDatetimeHelper.convertStringToDateTime(res.dt_delete) : res.dt_delete;
          this.form.email_create = res.email_create;
          this.form.email_update = res.email_update;
          this.form.email_delete = res.email_delete;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadData() {
      Promise.all([
        dropdownService.getAllOrigin(new URLSearchParams()),
        dropdownService.getAllCountries(new URLSearchParams()),
        dropdownService.getContent(new URLSearchParams()),
        dropdownService.getCharacteristic(new URLSearchParams()),
        dropdownService.getPeriodicity(new URLSearchParams()),
      ]).then((res) => {
          this.origins = res[0];
          this.country = res[1];
          this.content = res[2];
          this.characteristic = res[3];
          this.periodicity = res[4];
          if (this.isUpdate) {
            this.getCommodityDetails();
          }
        })
        .catch((err) => console.log(err));
    },
  },
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BTabs,
    BTab,
    BCard,
    vSelect
  },
};
</script>

<style lang="scss">
.subject-badge-select {
  margin-bottom: 10px;
  .badge {
    margin: 0px 5px;
  }
}
</style>